<section class="pt-16 px-container">
    <h1 class="text-5xl md:text-6xl">Abbecedario</h1>    
</section>

<section class="pt-16 px-container" [ngClass]="{'pb-16': definizioni_raggruppate.length !== 1}">
    <h4 class="lg:text-2xl text-xl font-medium mb-4">Cerca la definizione:</h4>
    <div class="flex lg:flex-row flex-col w-full">
        <p-autoComplete (onSelect)="onSelectDefinizione($event)" (onClear)="getData()" (completeMethod)="onFilterDefinizioni($event)" [suggestions]="definizioni_filtrate" field="titolo" class="autocomplete autocomplete-definizioni lg:w-4/5 w-full" placeholder="Info teatro" [emptyMessage]="'Nessuna definizione trovata!'" />                    
        <button class="clear lg:w-1/5 w-full lg:mt-0 mt-4 p-5 border border-[#ccc] button font-medium" type="button" [disabled]="definizioni_raggruppate.length !== 1" (click)="getData()">Pulisci la ricerca</button>
    </div>
</section>

<section *ngIf="definizioni_raggruppate.length !== 1" class="px-container">
    <nav class="nav w-full text-center flex flex-wrap flex-row justify-center">
        <a href="/abbecedario#A">A</a>
        <a href="/abbecedario#B">B</a>
        <a href="/abbecedario#C">C</a>
        <a href="/abbecedario#D">D</a>
        <a href="/abbecedario#E">E</a>
        <a href="/abbecedario#F">F</a>
        <a href="/abbecedario#G">G</a>
        <a href="/abbecedario#H">H</a>
        <a href="/abbecedario#I">I</a>
        <a href="/abbecedario#J">J</a>
        <a href="/abbecedario#K">K</a>
        <a href="/abbecedario#L">L</a>
        <a href="/abbecedario#M">M</a>
        <a href="/abbecedario#N">N</a>
        <a href="/abbecedario#O">O</a>
        <a href="/abbecedario#P">P</a>
        <a href="/abbecedario#Q">Q</a>
        <a href="/abbecedario#R">R</a>
        <a href="/abbecedario#S">S</a>
        <a href="/abbecedario#T">T</a>
        <a href="/abbecedario#U">U</a>
        <a href="/abbecedario#V">V</a>
        <a href="/abbecedario#W">W</a>
        <a href="/abbecedario#X">X</a>
        <a href="/abbecedario#Y">Y</a>
        <a href="/abbecedario#Z">Z</a>
    </nav>        
</section>

<section class="pb-16 mb-8 px-container">
    <div class="alfabeto flex flex-col gap-8" *ngFor="let alfabeto of definizioni_raggruppate">
        <h1 class="lg:text-6xl text-4xl font-bold uppercase mt-8 py-8" [id]="alfabeto.alfabeto">{{alfabeto.alfabeto}}</h1>
        <div class="definizione lg:px-8 border-[#ccccc] border-dashed relative" *ngFor="let definizione of alfabeto.elementi" [id]="definizione.id_definizione">
            <div class="top-1/2 left-0 absolute border-gray-300 border-l-2 border-dashed w-2 h-4/5 -translate-y-1/2"></div>
            <h1 class="lg:text-4xl text-2xl font-medium mb-8">{{definizione.titolo}}</h1>
            <div class="text-justify" [innerHTML]="definizione.definizione"></div>
        </div>
    </div>
</section>

<p-scrollTop />
